import { ComponentProps, FunctionComponent } from "react";
import { Home } from "../pages/Home";
import { MultiTabProductPage } from "../pages/MultiTabProductPage";
import { NewUserAgreementPage } from "../pages/NewUser/NewUserAgreementPage";
import { NewUserBillingPage } from "../pages/NewUser/NewUserBillingPage";
import { NewUserPhoneNumberPage } from "../pages/NewUser/NewUserPhoneNumberPage";
import { NewUserRootPage } from "../pages/NewUser/NewUserRootPage";
import { ProductListPage } from "../pages/ProductList/ProductListPage";
import { Analytics } from "../pages/Analytics";
import { LoginPage } from "../pages/LoginPage";
import { Registration } from "../pages/Registration";
import { Logout } from "../pages/Logout";
import { StoreListPage } from "../pages/StoreList/StoreListPage";
import { NewUserFirstProductRedirect } from "../pages/NewUser/NewUserFirstProductRedirect";
import { MultiTabSettingsPage } from "../pages/MultiTabSettingsPage";
import { MultiTabEditStorePage } from "../pages/Store/MultiTabEditStorePage";
import { Payouts } from "../pages/Payouts";
import { AdminOnlyMessages } from "../pages/AdminOnlyMessages";
import { MultiTabNewStorePage } from "../pages/Store/MultiTabNewStorePage";
import { CostPayoutModifierListPage } from "../pages/CostPayoutModifier/CostPayoutModifierListPage";

export type RouteProps = {
    path: string;
    component: FunctionComponent<any>;
    authenticated: boolean;
    gatedComponentEnabled?: boolean;
    gatedComponent?: FunctionComponent<any>;
    exact?: boolean;
    props?: ComponentProps<any>;
};

// The question mark denotes that the conversationSid param is optional.
export const MESSAGES_ROUTE_PATH = "/messages/:conversationSid?";
export const NEW_USER_FIRST_PRODUCT_PATH = "/new-user/first-product";

export const STORE_ROUTE_PATH = "/stores/:storeId/:tabId?";
export const NEW_STORE_ROUTE_PATH = "/stores/new/:tabId?";

export const SETTINGS_ROUTE_PATH = "/settings/:tabId?";

export const routes: RouteProps[] = [
    {
        path: "/login",
        component: LoginPage,
        authenticated: false
    },
    {
        path: "/logout",
        component: Logout,
        authenticated: false,
    },
    {
        path: "/registration",
        component: Registration,
        authenticated: false,
    },
    {
        path: "/products",
        component: ProductListPage,
        authenticated: true,
    },
    {
        path: "/products/:productListingId/:tabId?",
        component: MultiTabProductPage,
        authenticated: true,
    },
    {
        path: "/new-user",
        component: NewUserRootPage,
        gatedComponent: NewUserRootPage,
        authenticated: true
    },
    {
        path: "/new-user/phone-number",
        component: NewUserPhoneNumberPage,
        authenticated: true
    },
    {
        path: "/new-user/agreement",
        component: NewUserAgreementPage,
        authenticated: true
    },
    {
        path: "/new-user/billing",
        component: NewUserBillingPage,
        authenticated: true
    },
    {
        path: NEW_USER_FIRST_PRODUCT_PATH,
        component: NewUserFirstProductRedirect,
        authenticated: true
    },
    {
        path: NEW_STORE_ROUTE_PATH,
        component: MultiTabNewStorePage,
        authenticated: true,
    },
    {
        path: STORE_ROUTE_PATH,
        component: MultiTabEditStorePage,
        authenticated: true
    },
    {
        path: SETTINGS_ROUTE_PATH,
        component: MultiTabSettingsPage,
        authenticated: true,
    },
    {
        path: "/analytics",
        component: Analytics,
        authenticated: true,
    },
    {
        path: "/payouts",
        component: Payouts,
        authenticated: true,
    },
    {
        path: "/stores",
        component: StoreListPage,
        authenticated: true,
    },
    {
        path: "/cost-payout-modifiers",
        component: CostPayoutModifierListPage,
        authenticated: true,
    },
    {
        path: MESSAGES_ROUTE_PATH,
        component: AdminOnlyMessages,
        authenticated: true,
    },
    {
        path: "/",
        component: Home,
        authenticated: true,
        exact: true,
    },
];
